
const showError = (errorClass, messageKey) => {
    const errorBanner = document.querySelector(errorClass);
    errorBanner.classList.remove('hidden');
    const translatedMessage = errorBanner.dataset[messageKey ?? 'somethingWrong'];
    errorBanner.querySelector('.id-error').textContent = translatedMessage;
}

const hideError = (errorClass) => {
    const errorBanner = document.querySelector(errorClass);
    errorBanner.classList.add('hidden');
}